class AlertService {
    show
    title;
    message;
    type;

    constructor() {
        this.listeners = [];
    }

    setAlert(type, message) {
        this.show = true;
        this.title = type === 'error' ? 'Errore,' : 'Ok,'
        this.message = message;
        this.type = type;
        this.notifyListeners();
        setTimeout(() => {
            this.clearError();
        }, 3500);
    }

    clearError() {
        this.show = false;
        this.title = ''
        this.message = '';
        this.type = null;
        this.notifyListeners();
    }

    subscribe(listener) {
        this.listeners.push(listener);
        console.log(this.listeners)
    }

    unsubscribe(listener) {
        this.listeners = this.listeners.filter(l => l !== listener);
    }

    notifyListeners() {
        this.listeners.forEach(listener => listener(this.error));
    }
}

export default new AlertService();


// WEBPACK FOOTER //
// ./src/Services/alertService.js